<template>
    <form>
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Email Append Confirm Columns</h5>
                <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                  <form id="mashupForm" method="post">
                  <div>
                    <div>
                      <input type="hidden" id="mashupRetainFilename" v-model="mashupRetainFilename" name="filename">
                      <div class="form-group" id="mashupFormFields">
                        <label class="small mb-1" for="mashupFirstName">First Name</label>
                        <select name="firstname" id="mashupFirstName" v-model="mashupFirstName" class="form-select">
                          <option v-for="option in firstNameOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select><br>
                        <label class="small mb-1" for="mashupLastName">Last Name</label>
                        <select name="lastname" id="mashupLastName" v-model="mashupLastName" class="form-select">
                          <option v-for="option in lastNameOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select><br>
                        <label class="small mb-1" for="mashupAddress">Address</label>
                        <select name="address" id="mashupAddress" v-model="mashupAddress" class="form-select">
                          <option v-for="option in addressOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select><br>
                         <label class="small mb-1" for="mashupCity">City</label>
                        <select name="city" id="mashupCity" v-model="mashupCity" class="form-select">
                          <option v-for="option in cityOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select><br>
                         <label class="small mb-1" for="mashupState">State</label>
                        <select name="state" id="mashupState" v-model="mashupState" class="form-select">
                          <option v-for="option in stateOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select><br>
                        <label class="small mb-1" for="mashupZipCode">Zip Code</label>
                        <select name="zipcode" id="mashupZipCode" v-model="mashupZipCode" class="form-select">
                          <option v-for="option in zipCodeOptions" :value="option.id">
                            {{ option.name}}
                          </option>
                        </select>
                        <div>
                          <label class="small mb-1" for="mashupRange">Data Range</label>
                          <select name="range" id="mashupRange" v-model="mashupRange" class="form-select">
                            <option v-for="option in dataRange" :value="fixVal(option)">
                              {{ option}}
                            </option>
                          </select>
                        </div>
                        <div class="error lead" v-if="v$.form.$invalid">You require more email append credits to continue</div>
                          <div :class="{ error: v$.form.selectedvalue.$errors.length }">
                            <input type="hidden" v-model="v$.form.selectedvalue.$model" />
                            <div class="input-errors" v-for="error of v$.form.selectedvalue.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>   
                      </div>

                    </div>
                    <!-- div v-if="dataRange" -->
                    <div>
                      <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
                      <button type="button" class="btn btn-primary" id="mashupContinueButton" v-on:click="processUpload()" :disabled="v$.form.$invalid">Continue</button>
                    </div>
                  </div>
                </form>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import axios from 'axios';
//import { onMounted, ref } from "vue";
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: 'ModalEmailAppendMashupDialog',
  props: {
    passedModalData: {
      type: String,
      default() {
        return 'Dataset'
      }
    },
    passedMashupSi: {
      type: String,
      default() {
        return 'Dataset'
      }
    },
    passedMashupDv: {
      type: String,
      default() {
        return 'Dataset'
      }
    },
    passedMashupRf: {
      type: String,
      default() {
        return 'Dataset'
      }
    },
    passedMashupFt: {
      type: String,
      default() {
        return 'Dataset'
      }
    },
    userSubscription: []
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  data(){
    return{
      mashupRetainFilename: '',
      mashupFirstName: '',
      mashupLastName: '',
      mashupAddress: '',
      mashupCity: '',
      mashupState: '',
      mashupZipCode: '',
      mashupRange: '',
      firstNameOptions: [],
      lastNameOptions: [],
      addressOptions: [],
      cityOptions: [],
      stateOptions: [],
      zipCodeOptions: [],
      dataRange: [],
      form: {
                selectedvalue: []
            }
    }
  },
  validations () {
    return {
      form: {
        selectedvalue: { required }
      }
    }
  },
  methods: {
    processUpload(event) {
      const intialFormData = new FormData(document.getElementById("mashupForm"));
      const serializedData = new URLSearchParams(intialFormData).toString();
      console.log('the current serializaed data '+serializedData);
      axios({
        method: "POST",
        url: "/confirm_emailappend_mashup",
        data: serializedData
      })
      .then(
			(response) => {
        console.log('dataset mashup response: '+response.data);
        this.$emit('messageAlert', {alert: 'Your file has been uploaded.', classel: 'info'});
        this.$emit('customChangeAppend', {dataset: response.data, filename: this.mashupRetainFilename,range: this.mashupRange});
        this.$emit('closeModal');
      })
      .catch(
			(error) => {
        console.log(error);
        console.log('form submit failed');
      })
    },
    getIntervalls(max) {
      const nInt = 10000; // Interval size
      const ranges = [];
      let start = 1;
      let end = nInt;

      while (start <= max) {
        if (end > max) {
          end = max;
        }
        ranges.push(`${start}-${end}`);
        start = end + 1;
        end += nInt;
      }
      return ranges;
    },
    fixVal(val) {
      val = val.split('-')[1];
      return val
    }
  },
  mounted() {
    console.log('email mashup received data '+this.passedMashupSi+' '+this.passedMashupDv+' '+this.passedMashupRf+' '+JSON.stringify(this.passedMashupFt));
    this.mashupRetainFilename = this.passedMashupRf;
    for (var j = 0; j < this.passedMashupDv.length; j++) {
      this.firstNameOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
      this.lastNameOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
      this.addressOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
      this.cityOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
      this.stateOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
      this.zipCodeOptions.push({ id: j.toString(), name: this.passedMashupDv[j] });
    }
    this.mashupFirstName = this.passedMashupSi[0];
    this.mashupLastName = this.passedMashupSi[1];
    this.mashupAddress = this.passedMashupSi[2];
    this.mashupCity = this.passedMashupSi[3];
    this.mashupState = this.passedMashupSi[4];
    this.mashupZipCode = this.passedMashupSi[5];
    this.dataRange = this.getIntervalls(this.passedMashupFt.length);
    console.log('current user email number '+this.userSubscription.email);
    console.log('current mashup length '+this.passedMashupFt.length);
    if(this.userSubscription.email >= this.passedMashupFt.length) {
      this.form.selectedvalue = 'proceed';
    } else {
      this.form.selectedvalue = '';
    }
    console.log('current select value: ',this.form.selectedvalue);
    console.log('finalmashupvalues '+this.mashupFirstName+' '+this.mashupLastName+' '+this.mashupAddress+' '+this.mashupZipCode+' '+this.passedMashupFt.length+' '+JSON.stringify(this.dataRange));
  }
}
</script>